{
  "channels": "Каналы",
  "rules": "Правила",
  "deliveries": "Что отправлялось",
  "lastFifty": "последние 50",
  "addChannel": "Добавить канал",
  "addRule": "Добавить правило",
  "channelFirst": "Сначала заведите канал: правилу нужно, куда писать",
  "channelOn": "{{name}}: включён",
  "channelOff": "{{name}}: выключен",
  "ruleOn": "{{name}}: включено",
  "ruleOff": "{{name}}: выключено",
  "secretSet": "задан",
  "secretMissing": "нет",
  "testAria": "Проверить {{name}}",
  "testTitle": "Отправить пробное сообщение",
  "testSent": "Пробное сообщение ушло. Если оно не пришло — проверьте адрес получателя, а не канал.",
  "testFailed": "Пробное сообщение не дошло",
  "testFailedHint": "{{reason}}. Исправьте настройки канала и повторите проверку.",
  "unknownReason": "причина неизвестна",
  "editAria": "Изменить {{name}}",
  "deleteAria": "Удалить {{name}}",
  "editChannel": "Изменить канал",
  "deleteChannel": "Удалить канал вместе с его правилами",
  "editRule": "Изменить правило",
  "deleteRule": "Удалить правило",
  "channelsFailed": "Список каналов недоступен",
  "deleteChannelFailed": "Удалить канал не удалось",
  "rulesFailed": "Список правил недоступен",
  "logFailed": "Журнал недоступен",
  "saveFailed": "Сохранить не удалось",
  "noChannels": "Каналов пока нет",
  "noChannelsHint": "Канал — это адрес, куда платформа пишет об авариях: почта дежурного, чат в Telegram или webhook в чужую систему учёта. Начните с одного.",
  "noRules": "Правил пока нет",
  "noRulesHint": "Правило связывает условие с каналом: «падение любого узла — в чат дежурного». Без правил каналы молчат.",
  "noDeliveries": "Отправок не было",
  "noDeliveriesHint": "Здесь видно, что и куда уходило — в том числе неудачные попытки с причиной. Пока правила не сработали, журнал пуст.",
  "delivered": "доставлено",
  "notDelivered": "не доставлено",
  "ruleDeleted": "удалено",
  "channelDeleted": "удалён",
  "eventsHint": "событий в сообщении · подавлено штормом",
  "channelKind": {
    "email": "Электронная почта",
    "telegram": "Telegram",
    "webhook": "Webhook"
  },
  "status": {
    "down": "упал",
    "up": "поднялся",
    "unknown": "стал неизвестен"
  },
  "column": {
    "channel": "Канал",
    "kind": "Вид",
    "target": "Куда",
    "secret": "Секрет",
    "rule": "Правило",
    "condition": "Условие",
    "at": "Когда",
    "subject": "Содержание",
    "events": "Событий",
    "reason": "Причина"
  },
  "form": {
    "channelNameHint": "Как отличать канал в списке правил: «Чат дежурного», «Почта отдела»",
    "ruleNameHint": "«Падения на складе», «Всё дежурному»",
    "kindFixed": "Вид не меняется: у каждого своя форма настроек и свой смысл секрета. Нужен другой — заведите другой канал",
    "recipients": "Получатели",
    "recipientsHint": "Через запятую. Сам почтовый сервер задан переменными SMTP_URL и SMTP_FROM",
    "chat": "Чат",
    "chatHint": "Идентификатор чата или @имя канала. Группы — отрицательное число",
    "botToken": "Токен бота",
    "newBotToken": "Новый токен бота",
    "botTokenHint": "Выдаёт @BotFather. Бот должен быть добавлен в чат",
    "keepToken": "Пусто — оставить прежний токен",
    "urlHint": "POST с телом JSON. Только http и https",
    "signingKey": "Ключ подписи",
    "newSigningKey": "Новый ключ подписи",
    "signingKeyHint": "Нужен, если включена подпись тела. Пусто при правке — оставить прежний",
    "channelEnabled": "Канал включён",
    "silent": "Без звука",
    "sign": "Подписывать тело (HMAC-SHA256)",
    "signHint": "Приёмник сможет отличить наше уведомление от чужого запроса на тот же адрес",
    "notifyWhen": "Сообщать, когда узел",
    "noneMeansAll": "— ни одной отмеченной означает «все»",
    "checkKinds": "Виды проверок",
    "ruleEnabled": "Правило включено",
    "noTransitions": "Не отмечено ни одного перехода — такое правило не сработает никогда."
  },
  "rule": {
    "nothingHappens": "ничего не происходит",
    "or": " или ",
    "allSites": "на всех площадках",
    "atSites": "на площадках: {{list}}",
    "deletedSite": "удалённая",
    "anyCheck": "по любой проверке",
    "checks": "по проверкам {{list}}",
    "sentence": "узел {{statuses}} {{where}}, {{kinds}}"
  }
}
